import { Button, Stack } from '@mui/material'
import { appInsights } from '../../appInsights'
import { Page } from 'components/Shared/Page'

export const Insights = () => {
  return (
    <Page>
      <h1>Application Insights Testing page</h1>
      <Stack direction="row" gap={5} paddingTop={5}>
        <Button
          variant="contained"
          onClick={() => {
            throw new Error('Oops! Error from Control Center app')
          }}
        >
          Throw unhandled error
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            appInsights.trackEvent({
              name: 'My Custom Event from Control Center app',
            })
          }}
        >
          Track event
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            appInsights.trackException({
              exception: new Error('Tracked exception from Control Center app'),
            })
          }}
        >
          Track exception
        </Button>
      </Stack>
    </Page>
  )
}
